module.exports = __webpack_public_path__ + "img/pago-sin-contacto.35e71206.svg";